import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "featureId", "featureCategoryId", "isRegenerate", "onClick", "tooltip", "usageTracker", "usageTrackerAppLocationKey", "use"];
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { BREEZE_TOOLTIP_DELAY } from 'chatspot-core/constants/Delays';
import { BREEZE_SPECIAL } from '../../constants/BreezeUse';
import { useTracker } from '../../hooks/useTracker';
import { AIBaseLoadingButton } from './internal/AIBaseLoadingButton';
import { jsx as _jsx } from "react/jsx-runtime";
const AILoadingButton = _ref => {
  let {
      children,
      featureId,
      featureCategoryId,
      isRegenerate,
      onClick,
      tooltip,
      usageTracker,
      usageTrackerAppLocationKey,
      use
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    aiTracker
  } = useTracker(usageTracker, usageTrackerAppLocationKey);
  if (use === BREEZE_SPECIAL) {
    console.warn('BREEZE_SPECIAL is not meant for external use. Please use a different use type.');
  }
  const handleClick = event => {
    if (onClick) {
      onClick(event);
      if (aiTracker) {
        aiTracker.track('aiButtonInteraction', {
          type: 'trigger',
          featureId,
          featureCategoryId
        });
      }
    }
  };
  return /*#__PURE__*/_jsx(UITooltip, {
    delay: BREEZE_TOOLTIP_DELAY,
    title: tooltip,
    children: /*#__PURE__*/_jsx(AIBaseLoadingButton, Object.assign({}, props, {
      "data-test-id": props['data-test-id'] || 'ai-loading-button',
      onClick: handleClick,
      isRegenerate: isRegenerate,
      use: use || BREEZE_SPECIAL,
      children: children
    }))
  });
};
export default AILoadingButton;